module.exports = __webpack_public_path__ + "static/media/flag-en.14808eca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flag-en.svg
// module id = 845
// module chunks = 7